import { useEffect, useState } from "react";
import Navbar from "../../components/layout/Navbar";
import Footer from "../../components/layout/Footer";
import { api } from "../../lib/api";

export default function AdminAudit() {
    const [items, setItems] = useState([]);
    useEffect(() => { api.get("/admin/audit?limit=300").then((r) => setItems(r.data || [])); }, []);
    return (
        <div className="bg-paper min-h-screen">
            <Navbar />
            <main className="max-w-6xl mx-auto px-6 py-12">
                <p className="eyebrow mb-2">ADMIN · AUDIT</p>
                <h1 className="h2 mb-8">Activity log</h1>
                <div className="card-base">
                    {items.length === 0 && <div className="p-8 text-center text-sm text-ink-600">No events.</div>}
                    {items.map((e) => (
                        <div key={e.id} className="grid grid-cols-12 gap-4 px-4 py-3 border-b border-ink-200 text-sm last:border-b-0" data-testid={`audit-${e.id}`}>
                            <div className="col-span-3 font-mono text-xs text-ink-600">{new Date(e.timestamp).toLocaleString()}</div>
                            <div className="col-span-2 font-mono text-xs">{e.action}</div>
                            <div className="col-span-3 truncate">{e.target_type} · {e.target_id}</div>
                            <div className="col-span-4 text-xs text-ink-600 truncate">{Object.keys(e.details || {}).length ? JSON.stringify(e.details) : ""}</div>
                        </div>
                    ))}
                </div>
            </main>
            <Footer />
        </div>
    );
}
